(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("visibilityWizardStep2", {
        templateUrl: "app/learningPaths/visibility/steps/visibilityWizardStep2.component.html",
        require: {
            parentCtrl: "^^visibilityWizard"
        },
        controller: [VisibilityWizardStep2Ctrl],
        controllerAs: "vm"
    });
    function VisibilityWizardStep2Ctrl() {
        var vm = this;
        vm.statuses = [
            { "id": 0, "status": "Disabled" },
            { "id": 1, "status": "Assigned" },
            { "id": 2, "status": "Activated" },
            { "id": 3, "status": "Completed" },
            { "id": 4, "status": "Expired" },
            { "id": 5, "status": "Redo" },
            { "id": 6, "status": "AccessExpired" }
        ];
        this.$onInit = function () {
            vm.parentCtrl.stepIsValid = true;
            vm.visibility = vm.parentCtrl.visibility;
            vm.status = vm.parentCtrl.status;
        };
        //Function to determine if the form is valid
        vm.isValid = function () {
            vm.parentCtrl.visibility = vm.visibility;
            vm.parentCtrl.status = vm.status;
            if (vm.visibility === 2 && !(vm.status.length > 0)) {
                vm.parentCtrl.stepIsValid = false;
                vm.parentCtrl.selectionError = "Select at least one status to hide.";
                console.log("Not Valid");
            }
            else {
                vm.parentCtrl.stepIsValid = true;
                console.log("Valid");
            }
        };
    }
}());
